import { Temporal } from 'temporal-polyfill';
export { Temporal };
const CALENDAR_DATE_SHAPE = /^\d{4}-\d{2}-\d{2}$/;
/**
 * `Temporal.PlainDate.from` also takes `20261013` and date-times, so the shape is checked first.
 * This polyfill rejects an impossible day; the round trip keeps one refused even under a parser
 * that clamps it instead (`2026-02-30` read as `2026-02-28`), such as a native Temporal swap.
 */
export function plainDateOrNull(value) {
    if (!CALENDAR_DATE_SHAPE.test(value))
        return null;
    try {
        const plainDate = Temporal.PlainDate.from(value);
        return plainDate.toString() === value ? plainDate : null;
    }
    catch {
        return null;
    }
}
export function toPlainDate(value) {
    const plainDate = plainDateOrNull(value);
    if (!plainDate) {
        throw new RangeError(`Not a real YYYY-MM-DD calendar date: ${JSON.stringify(value)}`);
    }
    return plainDate;
}
export function toInstant(date) {
    const epochMilliseconds = date.getTime();
    if (Number.isNaN(epochMilliseconds))
        throw new RangeError('Invalid Date');
    return Temporal.Instant.fromEpochMilliseconds(epochMilliseconds);
}
//# sourceMappingURL=temporal.js.map